import { render, staticRenderFns } from "./jgbKDStatistic.vue?vue&type=template&id=6e563304&scoped=true"
import script from "./jgbKDStatistic.vue?vue&type=script&lang=js"
export * from "./jgbKDStatistic.vue?vue&type=script&lang=js"
import style0 from "./jgbKDStatistic.vue?vue&type=style&index=0&id=6e563304&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e563304",
  null
  
)

export default component.exports